import Vue from 'vue'
var index=0;
export function hasBtn(btnName)
{
    // return true
    var btn = sessionStorage.getItem('btnList') ? JSON.parse(sessionStorage.getItem('btnList')) : [];
    if (btn.length==0){
        return null
    }else {
        var link=[];
        btn.forEach(function(e,i) {
            link[i]=e.url;
        });
        return link.indexOf(btnName) > -1;
    }
}
export function getBtnStatus(path) {
    this.$post('admin_base_api/login',{path:path}).then((res)=>{
        if (res.status == 200){
            sessionStorage.setItem('btnList',res.data);
        }else {
            this.$message.error(res.message)
        }
        
    })
}
export function removeByIndex(arr,index) {
    for(var i=0; i<arr.length; i++) {
        if(i == index) {
            arr.splice(i, 1);
            break;
        }
    }
}
// 根据内容数组删除
export function removeByValue(arr, val) {
    for(var i=0; i<arr.length; i++) {
        if(arr[i] == val) {
            arr.splice(i, 1);
            break;
        }
    }
}
export function for_code(list,name){
    var new_list=[];
    for (var i = 0; i < list.length; i++) {
        new_list[list[i][name]] = list[i].name_cn;
    }
    return new_list;
}
export function getTime(/** timestamp=0 **/) {
    var ts = arguments[0] || 0;  
    var t,y,m,d,h,i,s;  
    t = ts ? new Date(ts*1000) : new Date();
    y = t.getFullYear();    //年
    m = t.getMonth()+1;    // 月
    d = t.getDate();    //日
    h = t.getHours();    //时
    i = t.getMinutes();    //分
    s = t.getSeconds();   //秒
    // 可根据需要在这里定义时间格式  
    if (arguments[1]=='y') {
        return y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d);
    }else if(arguments[1]=='m'){
        return (m<10?'0'+m:m)+'-'+(d<10?'0'+d:d);
    }else if(arguments[1]=='d'){
        return (d<10?'0'+d:d); 
    }else if(arguments[1]=='h'){
        return (h<10?'0'+h:h)+':'+(i<10?'0'+i:i)+':'+(s<10?'0'+s:s);  
    }else if(arguments[1]=='hi'){
        return (h<10?'0'+h:h)+':'+(i<10?'0'+i:i);  
    }else{
        return y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d)+' '+(h<10?'0'+h:h)+':'+(i<10?'0'+i:i)+':'+(s<10?'0'+s:s);  
    }
}
export function getTime_us(/** timestamp=0 **/) {  
    if (arguments[0]) {
        var ts = arguments[0] || 0;  
        var t,y,m,d,h,i,s;  
        t = ts ? new Date(ts*1000) : new Date();
        y = t.getFullYear();    //年
        m = t.getMonth()+1;    // 月
        d = t.getDate();    //日
        h = t.getHours();    //时
        i = t.getMinutes();    //分
        s = t.getSeconds();   //秒
        // 可根据需要在这里定义时间格式 
        if (arguments[1]=='yyyy') {
            return y 
        }else if (arguments[1]=='mmddyyyy'){
            // return (m<10?'0'+m:m)+'/'+(d<10?'0'+d:d)+'/'+y
            return y+'-'+(m<10?'0'+m:m) + '-' + (d<10?'0'+d:d)
        }else if(arguments[1]=='mmdd'){
            return (m<10?'0'+m:m)+'-'+(d<10?'0'+d:d)
        }else if(arguments[1]=='ampm'){
            return (h<10?'0'+h:h)+':'+(i<10?'0'+i:i)+':'+(s<10?'0'+s:s)
            // var ampm=((h >12) ? h -12 : h) + ':' + (i<10?'0'+i:i);
            // ampm+= (h >= 12) ? "pm" : "am";
            // return ampm;
        }else if(arguments[1]=='mmddyyyyampm'){
            return y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d)+' '+(h<10?'0'+h:h)+':'+(i<10?'0'+i:i)+':'+(s<10?'0'+s:s);
            // return (m<10?'0'+m:m)+'-'+(d<10?'0'+d:d)+'-'+y+' '+(h<10?'0'+h:h)+':'+(i<10?'0'+i:i)+':'+(s<10?'0'+s:s);
            // var ampm=((h >12) ? h -12 : h) + ':' + (i<10?'0'+i:i);
            // ampm+= (h >= 12) ? "pm" : "am";
            // return (m<10?'0'+m:m)+'/'+(d<10?'0'+d:d)+'/'+y+ '  ' +ampm;

        }else if(arguments[1]=='hh:ii'){
            return (h<10?'0'+h:h)+':'+(i<10?'0'+i:i);
        }else{
            return y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d)+' '+(h<10?'0'+h:h)+':'+(i<10?'0'+i:i)+':'+(s<10?'0'+s:s);
            // return (m<10?'0'+m:m)+'/'+(d<10?'0'+d:d)+'/'+y+' '+(h<10?'0'+h:h)+':'+(i<10?'0'+i:i)+':'+(s<10?'0'+s:s);  
        }
    }
    return '';
}
export function getTime_zone(/** timestamp=0 **/) {
    var t,y,m,d,h,i,s;  
    var targetTimezone = arguments[1];
    var ts = arguments[0] || 0;  
    var date = ts ? new Date(ts*1000) : new Date();
    var _dif = new Date().getTimezoneOffset();
    var t = new Date(date.getTime() + _dif * 60 * 1000 - (targetTimezone * 60 * 60 * 1000));
    y = t.getFullYear();    //年
    m = t.getMonth()+1;    // 月
    d = t.getDate();    //日
    h = t.getHours();    //时
    i = t.getMinutes();    //分
    s = t.getSeconds();   //秒
    // 可根据需要在这里定义时间格式  
    if (arguments[2]=='y') {
        return y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d);
    }else if(arguments[2]=='m'){
        return (m<10?'0'+m:m)+'-'+(d<10?'0'+d:d);
    }else if(arguments[2]=='d'){
        return (d<10?'0'+d:d); 
    }else if(arguments[2]=='h'){
        return (h<10?'0'+h:h)+':'+(i<10?'0'+i:i)+':'+(s<10?'0'+s:s);  
    }else{
        return y+'-'+(m<10?'0'+m:m)+'-'+(d<10?'0'+d:d)+' '+(h<10?'0'+h:h)+':'+(i<10?'0'+i:i)+':'+(s<10?'0'+s:s);  
    }
}

export function getTime_week(data){
    if (data) {
        var this_=this;
        var data_array=data?data.split(','):[];
        let dateObj =[];
        let show_day = new Array('Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday');
        let show_day_z = new Array('星期日','星期一','星期二','星期三','星期四','星期五','星期六');
        data_array.forEach(function(e,i) {
            let date = new Date(Number(e));
            let day = date.getDay();
            var show=(this_.lang=='cn'?show_day_z[day]:show_day[day]);
            dateObj[i]=show;
        });
        var hash=[];
        for (var i = 0; i < dateObj.length; i++) {
            if(hash.indexOf(dateObj[i])==-1){
                hash.push(dateObj[i]);
            }
        }
        return hash.length>0?hash.join(','):'';
    }else{
        return '';
    }
}
// 是否是手机
export function isMobile() {
    var userAgentInfo = navigator.userAgent;
    var mobileAgents = [ "Android", "iPhone", "SymbianOS", "Windows Phone", "iPad","iPod"];
    var mobile_flag = false;
    //根据userAgent判断是否是手机
    for (var v = 0; v < mobileAgents.length; v++) {
      if (userAgentInfo.indexOf(mobileAgents[v]) > 0) {
          mobile_flag = true;
          break;
      }
    }
    var screen_width = window.screen.width;
    var screen_height = window.screen.height;   
    //根据屏幕分辨率判断是否是手机
    if(screen_width < 500 && screen_height < 800){
       mobile_flag = true;
    }
    return mobile_flag;
}
export function xunhaun(list){
    var this_ = this;
    for (var i = 0; i < list.length; i++) {
        var e=list[i];
        e['list_index']=String(index);
        index=index+1;
        if (e.children) {
            this_.xunhaun(e.children);
        }
        if (!e.children||e.children.length==0) {
            delete e.children
        }
    }
    return list
}
export function router_url(url,data){
    var t=new Date().getTime();
    var tt={
        t:t
    };
    if (data) {
        data['t']=t;
    }else{
        data=tt;
    }
    this.$router.push({
        path: url,
        query: data,
    })
}
export function detectZoom() {
    let ratio = 0;
    var u = navigator.userAgent.match(/(Mac)/i);
    const screen = window.screen
    const ua = navigator.userAgent.toLowerCase();
    if (window.devicePixelRatio !== undefined) {
        ratio = window.devicePixelRatio;
    } else if (~ua.indexOf('msie')) {
        if (screen.deviceXDPI && screen.logicalXDPI) {
            ratio = screen.deviceXDPI / screen.logicalXDPI
        }
    } else if (window.outerWidth !== undefined && window.innerWidth !== undefined) {
        ratio = window.outerWidth / window.innerWidth
    }
    if (u==null) {
        document.body.style.zoom = 1 / ratio;
    }else{
        let windowWidth = document.documentElement.offsetWidth || document.body.offsetWidth;
        document.body.style.zoom = windowWidth / 1720
    }
}

export function getTime_us_f(data) {
    if (data) {
        var this_=this;
        var data_array=data?data.split(','):[];
        var arr=[];
        data_array.forEach(function(e,i) {
            if (e.length>10) {
                var date = new Date(Number(e));
            }else{
                var date = new Date(Number(e)*1000);
            }
            arr[i]=date.getFullYear();
        });
        let lastArr = []
        let sort_list = []
        let newArr = [...new Set(arr)];
        newArr.forEach(item=>{
            let num = 0
            arr.forEach(i=>{
                if(item==i){
                    num++
                }
            })
            lastArr.push({
                name:item,
                num
            });
            sort_list.push(num);
        })
        var num=sort_list.sort((a, b) => { return b-a })[0];
        var session=lastArr.filter(item => {return item.num==num})
        return session&&session[0].name;
    }else{
        return '';
    }
}



















//////////////////
// WEBPACK FOOTER
// ./store/store.js
// module id = null
// module chunks = 